import React, { useState, useEffect } from "react";
import { array } from "prop-types";

import Organism1 from "./Organism1";
import Organism2 from "./Organism2";
import LeftImageRightNews from "../../../molecules/LeftImageRightNews";

import "./row2.m.css";

const Row2 = ({ stories }) => {
  const [organism1Stories, setOrganism1Stories] = useState([]);
  const [organism2Stories, setOrganism2Stories] = useState([]);
  const [organism3Stories, setOrganism3Stories] = useState([]);

  useEffect(() => {
    setOrganism1Stories(stories.splice(0, 3));
    setOrganism2Stories(stories.splice(0, 6));
    setOrganism3Stories(stories.splice(0, 2));
  }, []);

  return (
    <div styleName="base">
      <div>
        <Organism1 stories={organism1Stories} />
        {organism2Stories.length > 0 && <Organism2 stories={organism2Stories} />}
      </div>
      {global.deviceWidth < 1264 && organism3Stories.length > 0 && (
        <div styleName="two-stories-wrapper">
          {organism3Stories.map((story, index) => (
            <LeftImageRightNews key={index} story={story.story} />
          ))}
        </div>
      )}
    </div>
  );
};

Row2.propTypes = {
  stories: array.isRequired,
};

export default Row2;
